import { createContext } from 'react';

export interface TransferredApplicationOverride {
  applicationData: any;
  refetchApplication: () => void;
}

export const CandidateContext = createContext({
  applicationId: '',
  applicationData: {},
  resourceUsage: null,
  modalRef: null,
  onContactLoaded: () => {},
  transferredStagesData: null as any,
  showAllStages: false,
  setShowAllStages: (_value: boolean) => {},
  transferredApplicationOverride: null as TransferredApplicationOverride | null,
});
